import { render, staticRenderFns } from "./InviteStaffModal.vue?vue&type=template&id=2e504ea4"
import script from "./InviteStaffModal.vue?vue&type=script&lang=js"
export * from "./InviteStaffModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports